// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__27NOv","col":"styles_col__1ef2b","fulfillmentStatus":"styles_fulfillmentStatus__1uvSu","emailCol":"styles_emailCol__6VvlV"};